import React from "react";
import { useStore as useAuthStore } from "auth/store";
import { useGetIndividualsCityReportQuery } from "core/queries/GetIndividualsCityReport";
import { useAppSelector } from "core/store";
import { ReportsList } from "reports/components/ReportsList";
import { ReportsViewContentLoader } from "reports/components/ReportsViewContentLoader";
import { ServiceUnavailableView } from "reports/components/ServiceUnavailableView";
import {
  getServiceUnavailableError,
  getTaskMetricsFilterInput,
} from "reports/utils";
import { useStore as useTasksStore } from "tasks/store";

export const ReportsIndividualsView = () => {
  const { state: authState } = useAuthStore();
  const { state: tasksState } = useTasksStore();
  const dateEndAt = useAppSelector(state => state.reports.dateEndAt);
  const dateStartAt = useAppSelector(state => state.reports.dateStartAt);

  const cityId = authState.user?.cityId;

  const { data, error, loading } = useGetIndividualsCityReportQuery({
    skip: !cityId || !dateEndAt || !dateStartAt,
    variables: {
      filter: getTaskMetricsFilterInput(
        authState,
        dateEndAt,
        dateStartAt,
        tasksState,
      ),
    },
  });

  const isServiceUnavailable = getServiceUnavailableError(error);

  if (isServiceUnavailable) return <ServiceUnavailableView />;
  if (loading) return <ReportsViewContentLoader />;

  const userMetrics = data?.cityTaskMetrics?.userMetrics;
  if (!userMetrics) {
    return null;
  }

  return <ReportsList metricTable={userMetrics} />;
};
